"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const Zoom_1 = __importDefault(require("@material-ui/core/Zoom"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const makeMyClasses = minWidth => ({
    root: {
        zIndex: 2000,
        minWidth,
    },
});
exports.Menu = (0, react_1.forwardRef)((props, ref) => {
    const { minWidth = 140, open = false, anchorEl, anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'left',
    }, transformOrigin = {
        vertical: 'top',
        horizontal: 'left',
    }, onClick, onClose, children, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [minWidth]);
    return (react_1.default.createElement(Menu_1.default, { ref: ref, open: open, TransitionComponent: Zoom_1.default, anchorEl: anchorEl, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, getContentAnchorEl: null, onClick: onClick, onClose: onClose, classes: { paper: myCss.root } }, children));
});
exports.default = exports.Menu;
